import { firestore } from '../utilities/firebase'
import errorTypes from '../enums/errorTypes'
import getCurrentUid from '../utilities/getCurrentUid'
import { errorOfType } from '../utilities/Errors'

const addKitToUserProfileByKitId = async ({ kitId }) => {
	try {
		const uid = getCurrentUid()

		const userProfilesCollRef = firestore.collection('userProfiles')
		// get user doc
		const userProfileDocRef = userProfilesCollRef.doc(uid)
		const userProfileDocSnap = await userProfileDocRef.get()
		// check for errors
		if (!userProfileDocSnap.exists) {
			return Promise.reject(errorOfType(errorTypes.NOTFOUND, { uid }))
		}
		// add kit to collection
		await userProfileDocRef.collection('kitsCreated').doc(kitId).set({ uid, kitId })

		// output
		return { kitId }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, kitId, exception)
	}
}

export default addKitToUserProfileByKitId



// WEBPACK FOOTER //
// ./src/dataservices/addKitToUserProfileByKitId.js